
































































import Vue from 'vue'
import store from '@/store'
import bus from '@/services/bus'

export default Vue.extend({
  // computed: {
  //   activeTab: {
  //     get (): string {
  //       return this.$route.name!
  //     },
  //     set () {

  //     }
  //   }
  // },
  data() {
    return {
      activeTab: this.$route.name || 'newslettersReadyList'
    }
  },
  watch: {
    $route (to, from) {
      const routeName = this.$route.name;

      if (routeName === 'newslettersReadyListPage') {
        this.activeTab = 'newslettersReadyList'
      } else if (routeName === 'newslettersInProgressListPage') {
        this.activeTab = 'newslettersInProgressList'
      } else if (routeName === 'newslettersComplitedListPage') {
        this.activeTab = 'newslettersComplitedList'
      } else if (routeName === 'newslettersCanceledListPage') {
        this.activeTab = 'newslettersCanceledList'
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      next()
    } catch (error) {
      next('notFound')
    }
  }
})
